import * as React from 'react';
import { Fieldset as FieldsetStandard } from '@emorg-prd/standard-react';

interface FieldsetProps extends Omit<React.ComponentProps<typeof FieldsetStandard>, 'twoColumned'> {
	legend: string;
	twoColumned?: boolean;
	className?: string;
	children: React.ReactNode;
}

const Fieldset: React.FC<FieldsetProps> = (props) => {
	const { legend, twoColumned, className, children, ...rest } = props;

	return (
		<FieldsetStandard
			{...rest}
			legend={legend}
			twoColumned={twoColumned}
			optionalClass={className}
		>
			{children}
		</FieldsetStandard>
	);
};

export { Fieldset };
